<template>
  <v-container class="d-flex flex-column justify-center">
    <div class="form mt-md-10 align-self-center">
      <h2 class="text-h5 font-weight-bold">Forgot Your Password</h2>
      <h5 class="subtitle-1">Enter your email to reset your password</h5>
      <div class="mt-5">
        <v-form>
          <v-progress-linear v-if="loading" indeterminate />
          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            data-testid="v-text-field"
            label="Email"
            @blur="$v.email.$touch()"
            @input="$v.email.$touch()"
          />
        </v-form>
      </div>
      <v-row class="my-3">
        <v-col class="d-flex flex-row mx-0 justify-center my-0 px-0 py-0">
          <v-btn
            :disabled="$v.$invalid || loading"
            class="btn-text pa-3 px-3"
            color="primary"
            data-testid="v-btn"
            @click="submit"
          >
            Reset Password
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Logo from "@/assets/guiomentorLogo.png";
import { email, required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      Logo,
      email: "",
      loading: false,
      description:
        "Guiomentor is a platform directed to a niche of 10 to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest ",
    };
  },
  metaInfo() {
    return {
      title: "Guiomentor - Forgot Password",
      url: window.location.href,
      meta: [
        { name: "title", content: "Guiomentor - Forgot Password" },
        {
          name: "description",
          content: this.description,
        },
        //Facebook
        { name: "og:type", content: "Website" },
        { name: "og:title", content: "Guiomentor - Forgot Password" },
        { name: "og:description", content: this.description },
        { name: "og:image", content: this.Logo },

        // Twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:url", content: window.location.href },
        { name: "twitter:title", content: "Guiomentor - Forgot Password" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.Logo },
      ],
    };
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        const body = { email: this.email };
        await this.axios.post("password_reset/", body);
        this.$snackbar.showMessage({
          content: "check your email to reset your password",
          color: "success",
        });
        this.email = "";
        this.$v.$reset();
      } catch (error) {
        this.$snackbar.showMessage({
          content:
            error.response.data.email[0] ||
            this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.loading = false;
        this.$analytics.logEvent("forgot_password", {
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
      }
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.$t("auth.forms.errors.emailMustBeValid"));
      !this.$v.email.required &&
        errors.push(this.$t("auth.forms.errors.emailRequired"));
      this.emailTaken &&
        errors.push(this.$t("errors.emailTaken", { email: this.email }));
      return errors;
    },
  },
  validations: {
    email: { required, email },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.full-container {
  height: 100vh;

  .row {
    margin: 0;
  }
}

.left {
  background: #0033aa;
  height: 100vh;
  margin-top: 0;
  margin-bottom: 0;

  .logo {
    width: 130px;
    height: 130px;
  }

  .mini-column {
    elevation: higher;
    background: linear-gradient(to right, #b7edeb, #54ded2);
    min-height: 70%;
    max-width: 95%;
    border-radius: 5px;
  }
}

.right {
  background: #f5f6f8;
  height: 100vh;
}

.form {
  background: #ffffff;
  min-height: 350px;
  width: 85%;
  border-radius: 10px;
  padding: 35px;
  box-shadow: 0px 42px 100px rgba(0, 0, 0, 0.12);

  .v-btn {
    text-transform: none !important;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .form {
    width: 100% !important;
  }
}
</style>
